<template>
	<div class="switcher-container">
		<div :class="{'active': !value }" class="switcher-label">
			{{ disabledLabel }}
		</div>
		<checkbox :value="value" mode="switcher" @input="$emit('input', $event)" />
		<div :class="{'active': value }" class="switcher-label">
			{{ enabledLabel }}
		</div>
	</div>
</template>

<script>
import Checkbox from './Checkbox'

export default {
	name: 'Switcher',
	components: { Checkbox },
	props: {
		value: {
			type: Boolean,
			default: false
		},
		enabledLabel: {
			type: String,
			default: ''
		},
		disabledLabel: {
			type: String,
			default: ''
		}
	}
}
</script>

<style lang="scss">
	.switcher-container {
		display: flex;
		align-items: center;
		justify-content: center;

		.switcher-label {
			opacity: 0.6;

			&.active {
				opacity: 1;
			}
		}
	}
</style>
